import React, { useState } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Avatar from '@material-ui/core/Avatar';
import ErrorIcon from '@material-ui/icons/Error';
import Toolbar from '@material-ui/core/Toolbar';
import { Grid, Typography, CircularProgress, Button } from '@material-ui/core/';
import { getIcError } from '../../../core/providers/utils';
import ButtonMUI from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { FormDataConsumer, refreshView, Loading } from 'react-admin';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import TabContext from '@material-ui/lab/TabContext';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { useNotify } from 'ra-core';

import { ExcelIcon } from '../../../core/themes/icons/ExcelIcon';
import DialogTitleWithCloseButton from '../../../core/components/DialogTitleWithCloseButton';
import FileInput from '../../../core/components/forked/input/FileInput';
import FileField from '../../../core/components/forked/field/FileField';
import UserApi from '../../../core/apis/UserApi';
import { saveAs } from 'file-saver';
import useNotifyServerError from '../../../core/hooks/useNotifyServerError';
import CustomSimpleForm from '../../../core/components/form/CustomSimpleForm';

const styles = {
  avatar: {
    marginRight: 0,
    marginLeft: 0,
    verticalAlign: 'middle',
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
    height: '36px',
    width: '36px',
    color: '#757575'
  },
  errorIcon: {
    marginRight: 0,
    marginLeft: 0,
    verticalAlign: 'middle',
    color: 'red'
  },
  toolbarStyle: {
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #E5E5E5',
    minHeight: '54px',
    paddingTop: '0',
    paddingBottom: '0'
  },
  firstButtonStyle: {
    minHeight: '30px',
    padding: '5px 10px'
  },
  buttonStyle: {
    minHeight: '30px',
    padding: '5px 10px',
    marginRight: '10px'
  },
  root: {
    flexGrow: 1
  },
  barTitle: {
    flexGrow: 1,
    paddingLeft: '8px'
  },
  label: {
    paddingRight: '0px'
  },
  horisontalRule: {
    height: '1px',
    backgroundColor: '#E0E0E0',
    border: 'none'
  },
  ButtonMUISpan: {
    paddingLeft: '4px'
  },
  excelIcon: {
    verticalAlign: 'middle',
    paddingRight: '10px'
  },
  warningIcon: {
    marginRight: 0,
    marginLeft: 0,
    verticalAlign: 'middle',
    color: 'orange'
  },
  validationColumnWarning: {
    color: 'orange'
  },
  paperWidthFalse: {
    height: 'inherit',
    width: '100%'
  },
  leftWrapper: {
    flexGrow: 1
  },
  validateButton: {
    textAlign: 'center',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  validateButtonText: {
    color: 'grey'
  },
  validationColumn: {
    color: 'red'
  },
  noRows: {
    color: 'red'
  },
  noRowsBlack: {
    color: 'black'
  },
  circularProgress: {
    paddingRight: '3px'
  },
  tabsStyle: {
    color: 'black',
    background: 'transparent'
  },
  tableWrapper: {
    maxHeight: '70vh',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px'
    },
    /* Track */
    '&::-webkit-scrollbar-track': {
      background: '#ebebeb',
      borderRadius: '10px',
      margin: '2px'
    },
    /* Handle */
    '&::-webkit-scrollbar-thumb': {
      background: '#9E9E9E',
      borderRadius: '10px'
    },
    /* Handle on hover */
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#7b7a7a'
    }
  },
  table: {
    overflow: 'auto',
    maxHeight: 'calc(100vh - 364px)',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px'
    },
    /* Track */
    '&::-webkit-scrollbar-track': {
      background: '#ebebeb',
      borderRadius: '10px',
      margin: '2px'
    },
    /* Handle */
    '&::-webkit-scrollbar-thumb': {
      background: '#9E9E9E',
      borderRadius: '10px'
    },
    /* Handle on hover */
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#7b7a7a'
    }
  }
};

const AvatarImage = withStyles(styles)(({ classes, icon }) => {
  return <Avatar className={classes.avatar}>{icon}</Avatar>;
});

const ErrorImage = withStyles(styles)(({ classes, icon }) => {
  return <ErrorIcon className={classes.errorIcon}>{icon}</ErrorIcon>;
});

const ExcelIconImage = withStyles(styles)(({ classes, icon }) => {
  return <ExcelIcon className={classes.excelIcon}>{icon}</ExcelIcon>;
});

const WarningImage = withStyles(styles)(({ classes, icon }) => {
  return <ErrorIcon className={classes.warningIcon}>{icon}</ErrorIcon>;
});

const StyledFileInput = withStyles({
  dropZone: {
    background: '#ffffff',
    border: '1px dashed #E0E0E0'
  },
  removeButton: {
    textAlign: 'center',
    padding: '.5rem'
  }
})(FileInput);

const ExcelContactImportTitleBarWithDropbox = withStyles(styles)(
  ({
    classes,
    type,
    title,
    createUrl,
    secondTitle,
    secondCreateUrl,
    icon,
    hasCreatePermission,
    hasExportUsersExcelPermission,
    hasImportUserExcelPermission,
    filters,
    selectedIds,
    ...rest
  }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [importModelViewToggle, setsViewOfImport] = useState(false);
    const [validateButtonVisibile, setValidateButtonVisibility] = useState(
      false
    );
    const [submitting, setSubmitting] = useState(false);
    const [disableImportButton, setImportButtonDisabled] = useState(true);
    const [loaderVisible, setLoaderVisible] = useState(false);
    const [showGrid, setShowGrid] = useState(false);
    const [showNoDataInExcelError, setShowNoDataInExcelError] = useState(false);
    const [isFileFieldDisabled, setIsFileFieldDisabled] = useState(false);
    const [downloadingTemplate, setDownloadingTemplate] = useState(false);
    const [excelFileData, setExcelFileData] = useState('');

    const [value, setValue] = useState('1');
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState(-1);
    const [response, setResponse] = useState('');
    const [responseTab2, setResponseTab2] = useState('');
    const [responseTab3, setResponseTab3] = useState('');
    const [responseTab4, setResponseTab4] = useState('');
    const [responseTab5, setResponseTab5] = useState('');
    const [responseTab6, setResponseTab6] = useState('');
    const [responseTab7, setResponseTab7] = useState('');
    const [responseTab8, setResponseTab8] = useState('');
    const [tab1ContainsErrors, setTab1ContainsErrors] = useState(false);
    const [tab1ContainsWarning, setTab1ContainsWarning] = useState(false);
    const [tab2ContainsErrors, setTab2ContainsErrors] = useState(false);
    const [tab3ContainsErrors, setTab3ContainsErrors] = useState(false);
    const [tab4ContainsErrors, setTab4ContainsErrors] = useState(false);
    const [tab5ContainsErrors, setTab5ContainsErrors] = useState(false);
    const [tab6ContainsErrors, setTab6ContainsErrors] = useState(false);
    const [tab7ContainsErrors, setTab7ContainsErrors] = useState(false);
    const [tab8ContainsErrors, setTab8ContainsErrors] = useState(false);
    const [tab8ContainsWarning, setTab8ContainsWarning] = useState(false);
    const [propertiesDataModel, setPropertiesDataModel] = useState(false);

    const notify = useNotify();
    const notifyServerError = useNotifyServerError();

    const handleClick = event => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleImportClick = () => {
      setAnchorEl(null);
      setsViewOfImport(true);
    };

    const handleCloseImportClick = () => {
      setAnchorEl(null);
      cleanUpData();
      setsViewOfImport(false);
    };

    function compareAscending(x, y) {
      return x < y ? -1 : x > y ? 1 : 0;
    }

    function compareDescending(x, y) {
      return x < y ? 1 : x > y ? -1 : 0;
    }

    const handleRequestSort = index => {
      const isDesc = order === 'desc';
      isDesc ? setOrder('asc') : setOrder('desc');
      setOrderBy(index);

      var sortColumnName;
      switch (index) {
        case 0:
          sortColumnName = 'rowNum';
          break;
        case 1:
          sortColumnName = 'email';
          break;
        case 2:
          sortColumnName = 'firstName';
          break;
        case 3:
          sortColumnName = 'middleName';
          break;
        case 4:
          sortColumnName = 'lastName';
          break;
        case 5:
          sortColumnName = 'userType';
          break;
        case 6:
          sortColumnName = 'status';
          break;
        case 7:
          sortColumnName = 'companyName';
          break;
        case 8:
          sortColumnName = 'emailOptOut';
          break;
        case 9:
          sortColumnName = 'receiveDailySummary';
          break;
        case 10:
          sortColumnName = 'title';
          break;
        case 11:
          sortColumnName = 'salutation';
          break;
        case 12:
          sortColumnName = 'suffix';
          break;
        case 13:
          sortColumnName = 'ccEmail';
          break;
        case 14:
          sortColumnName = 'syncToExternalResource';
          break;
        case 15:
          sortColumnName = 'businessAddressLine1';
          break;
        case 16:
          sortColumnName = 'businessAddressLine2';
          break;
        case 17:
          sortColumnName = 'businessAddressLine3';
          break;
        case 18:
          sortColumnName = 'city';
          break;
        case 19:
          sortColumnName = 'stateOrProvince';
          break;
        case 20:
          sortColumnName = 'zipOrPostalCode';
          break;
        case 21:
          sortColumnName = 'country';
          break;
        case 22:
          sortColumnName = 'phoneNumber';
          break;
        case 23:
          sortColumnName = 'extension';
          break;
        case 24:
          sortColumnName = 'verifiedByUser';
          break;
        case 25:
          sortColumnName = 'validationError';
          break;
        default:
          sortColumnName = 'rowNum';
      }

      var sortedTableData = response.sort(function(a, b) {
        var x = a[sortColumnName]
          ? a[sortColumnName].toString().toLowerCase()
          : '';
        var y = b[sortColumnName]
          ? b[sortColumnName].toString().toLowerCase()
          : '';
        if (sortColumnName === 'rowNum') {
          return isDesc ? x - y : y - x;
        }
        if (isDesc) {
          return compareAscending(x, y);
        } else {
          return compareDescending(x, y);
        }
      });

      setResponse(sortedTableData);
    };

    const handleRequestTab2Sort = index => {
      const isDesc = order === 'desc';
      isDesc ? setOrder('asc') : setOrder('desc');
      setOrderBy(index);

      var sortColumnName;
      switch (index) {
        case 0:
          sortColumnName = 'rowNum';
          break;
        case 1:
          sortColumnName = 'userEmail';
          break;
        case 2:
          sortColumnName = 'fundId';
          break;
        case 3:
          sortColumnName = 'investorId';
          break;
        case 4:
          sortColumnName = 'groupName';
          break;
        case 5:
          sortColumnName = 'validationError';
          break;
        default:
          sortColumnName = 'rowNum';
      }

      var sortedTableData = responseTab2.sort(function(a, b) {
        var x = a[sortColumnName]
          ? a[sortColumnName].toString().toLowerCase()
          : '';
        var y = b[sortColumnName]
          ? b[sortColumnName].toString().toLowerCase()
          : '';
        if (sortColumnName === 'rowNum') {
          return isDesc ? x - y : y - x;
        }
        if (isDesc) {
          return compareAscending(x, y);
        } else {
          return compareDescending(x, y);
        }
      });

      setResponse(sortedTableData);
    };

    const handleRequestTab3Sort = index => {
      const isDesc = order === 'desc';
      isDesc ? setOrder('asc') : setOrder('desc');
      setOrderBy(index);

      var sortColumnName;
      switch (index) {
        case 0:
          sortColumnName = 'rowNum';
          break;
        case 1:
          sortColumnName = 'userEmail';
          break;
        case 2:
          sortColumnName = 'fundId';
          break;
        case 3:
          sortColumnName = 'investorId';
          break;
        case 4:
          sortColumnName = 'groupName';
          break;
        case 5:
          sortColumnName = 'validationError';
          break;
        default:
          sortColumnName = 'rowNum';
      }

      var sortedTableData = responseTab3.sort(function(a, b) {
        var x = a[sortColumnName]
          ? a[sortColumnName].toString().toLowerCase()
          : '';
        var y = b[sortColumnName]
          ? b[sortColumnName].toString().toLowerCase()
          : '';
        if (sortColumnName === 'rowNum') {
          return isDesc ? x - y : y - x;
        }
        if (isDesc) {
          return compareAscending(x, y);
        } else {
          return compareDescending(x, y);
        }
      });

      setResponse(sortedTableData);
    };

    const handleRequestTab4Sort = index => {
      const isDesc = order === 'desc';
      isDesc ? setOrder('asc') : setOrder('desc');
      setOrderBy(index);

      var sortColumnName;
      switch (index) {
        case 0:
          sortColumnName = 'rowNum';
          break;
        case 1:
          sortColumnName = 'userEmail';
          break;
        case 2:
          sortColumnName = 'roleName';
          break;
        case 3:
          sortColumnName = 'validationError';
          break;
        default:
          sortColumnName = 'rowNum';
      }

      var sortedTableData = responseTab4.sort(function(a, b) {
        var x = a[sortColumnName]
          ? a[sortColumnName].toString().toLowerCase()
          : '';
        var y = b[sortColumnName]
          ? b[sortColumnName].toString().toLowerCase()
          : '';
        if (sortColumnName === 'rowNum') {
          return isDesc ? x - y : y - x;
        }
        if (isDesc) {
          return compareAscending(x, y);
        } else {
          return compareDescending(x, y);
        }
      });

      setResponse(sortedTableData);
    };
    const handleRequestTab5Sort = index => {
      const isDesc = order === 'desc';
      isDesc ? setOrder('asc') : setOrder('desc');
      setOrderBy(index);

      var sortColumnName;
      switch (index) {
        case 0:
          sortColumnName = 'rowNum';
          break;
        case 1:
          sortColumnName = 'userEmail';
          break;
        case 2:
          sortColumnName = 'roleName';
          break;
        case 3:
          sortColumnName = 'validationError';
          break;
        default:
          sortColumnName = 'rowNum';
      }

      var sortedTableData = responseTab5.sort(function(a, b) {
        var x = a[sortColumnName]
          ? a[sortColumnName].toString().toLowerCase()
          : '';
        var y = b[sortColumnName]
          ? b[sortColumnName].toString().toLowerCase()
          : '';
        if (sortColumnName === 'rowNum') {
          return isDesc ? x - y : y - x;
        }
        if (isDesc) {
          return compareAscending(x, y);
        } else {
          return compareDescending(x, y);
        }
      });

      setResponse(sortedTableData);
    };

    const handleRequestTab6And7Sort = (index, responseTab) => {
      const isDesc = order === 'desc';
      isDesc ? setOrder('asc') : setOrder('desc');
      setOrderBy(index);

      var sortColumnName;
      switch (index) {
        case 0:
          sortColumnName = 'rowNum';
          break;
        case 1:
          sortColumnName = 'userEmail';
          break;
        case 2:
          sortColumnName = 'fundId';
          break;
        case 3:
          sortColumnName = 'investorId';
          break;
        case 4:
          sortColumnName = 'documentType';
          break;
        case 5:
          sortColumnName = 'validationError';
          break;
        default:
          sortColumnName = 'rowNum';
      }

      var sortedTableData = responseTab.sort(function(a, b) {
        var x = a[sortColumnName]
          ? a[sortColumnName].toString().toLowerCase()
          : '';
        var y = b[sortColumnName]
          ? b[sortColumnName].toString().toLowerCase()
          : '';
        if (sortColumnName === 'rowNum') {
          return isDesc ? x - y : y - x;
        }
        if (isDesc) {
          return compareAscending(x, y);
        } else {
          return compareDescending(x, y);
        }
      });

      setResponse(sortedTableData);
    };

    const handleRequestTab8Sort = index => {
      const isDesc = order === 'desc';
      isDesc ? setOrder('asc') : setOrder('desc');
      setOrderBy(index);
      let sortByErrorMessage = false;
      if (index === propertiesDataModel.length - 1) {
        sortByErrorMessage = true;
      }
      var sortedTableData = responseTab8.sort(function(a, b) {
        let x, y;
        if (index === 0) {
          // Row Num
          x = a.rowNumber;
          y = b.rowNumber;
          return isDesc ? x - y : y - x;
        } else if (index === 1) {
          // Email
          x = a.email.toLowerCase();
          y = b.email.toLowerCase();
        } else if (sortByErrorMessage) {
          x = a.validationError.toLowerCase();
          y = b.validationError.toLowerCase();
        } else {
          x = a.validatedFieldUdfModels[index - 2].fieldValue.toLowerCase();
          y = b.validatedFieldUdfModels[index - 2].fieldValue.toLowerCase();
        }

        if (isDesc) {
          return compareAscending(x, y);
        } else {
          return compareDescending(x, y);
        }
      });

      setResponseTab6(sortedTableData);
    };

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const cleanUpData = value => {
      setTab1ContainsErrors(false);
      setTab1ContainsWarning(false);
      setTab2ContainsErrors(false);
      setTab3ContainsErrors(false);
      setTab4ContainsErrors(false);
      setTab5ContainsErrors(false);
      setTab6ContainsErrors(false);
      setTab7ContainsErrors(false);
      setTab8ContainsErrors(false);
      setTab8ContainsWarning(false);
      setShowGrid(false);
      setImportButtonDisabled(true);
      setShowNoDataInExcelError(false);
      if (value) {
        setValidateButtonVisibility(true);
      } else {
        setValidateButtonVisibility(false);
      }
    };

    const handleClickValidation = async values => {
      var payload = new FormData();
      if (values.file) {
        payload.append('excelFile', values.file.rawFile, values.file.title);
        setExcelFileData(values);
      }

      setValidateButtonVisibility(false);
      setImportButtonDisabled(true);
      setLoaderVisible(true);
      setIsFileFieldDisabled(true);
      try {
        const responseData = await UserApi.validateImportFromExcel(payload);
        var arrayData = responseData['validatedContactDetails'];
        setResponse(arrayData);

        var arrayDataTab2 = responseData['addedAuthorizations'];
        setResponseTab2(arrayDataTab2);

        var arrayDataTab3 = responseData['deletedAuthorizations'];
        setResponseTab3(arrayDataTab3);

        var arrayDataTab4 = responseData['addedUserRoles'];
        setResponseTab4(arrayDataTab4);

        var arrayDataTab5 = responseData['deletedUserRoles'];
        setResponseTab5(arrayDataTab5);

        var arrayDataTab6 = responseData['addedUserNotifications'];
        setResponseTab6(arrayDataTab6);

        var arrayDataTab7 = responseData['deletedUserNotifications'];
        setResponseTab7(arrayDataTab7);

        var arrayDataTab8 = responseData['validatedContactUdfs'];
        setResponseTab8(arrayDataTab8);

        // Extract datamodel of the UDF from the first row if any
        if (arrayDataTab8.length > 0) {
          let dataModel = [{ id: 'Row Number' }, { id: 'Email' }];
          arrayDataTab8[0].validatedFieldUdfModels.forEach(obj => {
            dataModel.push({
              id: obj.fieldName
            });
          });
          dataModel.push({ id: 'Validation Error / Warning message' });
          setPropertiesDataModel(dataModel);
        }

        const validationErrors = arrayData
          .slice(0)
          .filter(r => r.validationError !== '');
        validationErrors.length > 0 && setTab1ContainsErrors(true);

        const validationWarningTab1 = arrayData
          .slice(0)
          .filter(r => r.warningMessage !== '');
        validationWarningTab1.length > 0 && setTab1ContainsWarning(true);

        const validationErrorsTab2 = arrayDataTab2
          .slice(0)
          .filter(r => r.validationError !== '');
        validationErrorsTab2.length > 0 && setTab2ContainsErrors(true);

        const validationErrorsTab3 = arrayDataTab3
          .slice(0)
          .filter(r => r.validationError !== '');
        validationErrorsTab3.length > 0 && setTab3ContainsErrors(true);

        const validationErrorsTab4 = arrayDataTab4
          .slice(0)
          .filter(r => r.validationError !== '');
        validationErrorsTab4.length > 0 && setTab4ContainsErrors(true);

        const validationErrorsTab5 = arrayDataTab5
          .slice(0)
          .filter(r => r.validationError !== '');
        validationErrorsTab5.length > 0 && setTab5ContainsErrors(true);

        const validationErrorsTab6 = arrayDataTab6
          .slice(0)
          .filter(r => r.validationError !== '');
        validationErrorsTab6.length > 0 && setTab6ContainsErrors(true);

        const validationErrorsTab7 = arrayDataTab7
          .slice(0)
          .filter(r => r.validationError !== '');
        validationErrorsTab7.length > 0 && setTab7ContainsErrors(true);

        const validationErrorsTab8 = arrayDataTab8
          .slice(0)
          .filter(r => r.validationError !== '');
        validationErrorsTab8.length > 0 && setTab8ContainsErrors(true);

        const validationWarningTab8 = arrayDataTab8
          .slice(0)
          .filter(r => r.warningMessage !== '');
        validationWarningTab8.length > 0 && setTab8ContainsWarning(true);

        if (
          arrayData.length > 0 ||
          arrayDataTab2.length > 0 ||
          arrayDataTab3.length > 0 ||
          arrayDataTab4.length > 0 ||
          arrayDataTab5.length > 0 ||
          arrayDataTab6.length > 0 ||
          arrayDataTab7.length > 0 ||
          arrayDataTab8.length > 0
        ) {
          var errors = false;
          if (
            arrayData.length > 0 &&
            validationErrors &&
            validationErrors.length > 0
          ) {
            errors = true;
          }
          if (
            arrayDataTab2.length > 0 &&
            validationErrorsTab2 &&
            validationErrorsTab2.length > 0
          ) {
            errors = true;
          }
          if (
            arrayDataTab3.length > 0 &&
            validationErrorsTab3 &&
            validationErrorsTab3.length > 0
          ) {
            errors = true;
          }

          if (
            arrayDataTab4.length > 0 &&
            validationErrorsTab4 &&
            validationErrorsTab4.length > 0
          ) {
            errors = true;
          }

          if (
            arrayDataTab5.length > 0 &&
            validationErrorsTab5 &&
            validationErrorsTab5.length > 0
          ) {
            errors = true;
          }

          if (
            arrayDataTab6.length > 0 &&
            validationErrorsTab6 &&
            validationErrorsTab6.length > 0
          ) {
            errors = true;
          }

          if (
            arrayDataTab7.length > 0 &&
            validationErrorsTab7 &&
            validationErrorsTab7.length > 0
          ) {
            errors = true;
          }

          if (
            arrayDataTab8.length > 0 &&
            validationErrorsTab8 &&
            validationErrorsTab8.length > 0
          ) {
            errors = true;
          }

          setImportButtonDisabled(errors);
        } else {
          setImportButtonDisabled(true);
          setShowNoDataInExcelError(true);
        }

        setLoaderVisible(false);
        setIsFileFieldDisabled(false);
        setShowGrid(true);
      } catch (e) {
        setLoaderVisible(false);
        setIsFileFieldDisabled(false);
        notifyServerError(e);
      }
    };

    const handleImportContactsClick = async values => {
      setImportButtonDisabled(true);
      setLoaderVisible(true);
      setShowGrid(false);
      setIsFileFieldDisabled(true);
      var payload = new FormData();
      if (values && values.file) {
        payload.append('excelFile', values.file.rawFile, values.file.title);
      }

      try {
        await UserApi.importUsersFromExcel(payload);
        notify('ra.notification.custom_updated_message');
      } catch (e) {
        setLoaderVisible(false);
        notifyServerError(e);
      } finally {
        setShowGrid(false);
        setLoaderVisible(false);
        setsViewOfImport(false);
        setIsFileFieldDisabled(false);
        refreshView();
      }
    };

    /**
     * Click on button 'Download as Excel' to download the excel file
     */
    const handleClickDownloadAsExcel = async () => {
      setDownloadingTemplate(true);
      UserApi.getContactExcelTemplate()
        .then(resp => {
          const fileName = 'Contact Import Template.xlsx';
          saveAs(resp, fileName);
        })
        .catch(e => {
          notify(getIcError(e), { type: 'error' });
        })
        .finally(() => {
          setDownloadingTemplate(false);
        });
    };

    const handleExportClick = filters => {
      setSubmitting(true);
      UserApi.exportUsersExcel(
        filters.name,
        filters.fundFamilyId,
        filters.id,
        filters.mupUserId,
        filters.email,
        filters.status,
        filters.orphanVisibility,
        selectedIds
      )
        .then(resp => {
          const fileName = 'Contacts Export.xlsx';
          saveAs(resp, fileName);
          setSubmitting(false);
        })
        .catch(e => {
          notifyServerError(e);
          setSubmitting(false);
        });
    };

    return (
      <Toolbar className={classes.toolbarStyle}>
        <AvatarImage icon={icon} />

        <Typography
          style={{ fontSize: '20px', lineHeight: '28px' }}
          color="textPrimary"
          className={classes.barTitle}
        >
          {type}
        </Typography>
        {(hasImportUserExcelPermission || hasExportUsersExcelPermission) && (
          <div>
            <ButtonMUI
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              <div className={classes.WrapperClass}>
                <ExcelIconImage />
                <span className={classes.ButtonMUISpan}>
                  Import/Export Contacts
                </span>
              </div>
            </ButtonMUI>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {hasImportUserExcelPermission && (
                <MenuItem onClick={handleImportClick}>
                  Import Contacts from Excel
                </MenuItem>
              )}
              {hasExportUsersExcelPermission && (
                <MenuItem
                  onClick={() => handleExportClick(filters)}
                  disabled={submitting}
                >
                  {submitting && (
                    <span className={classes.circularProgress}>
                      <CircularProgress size={'15px'} />
                    </span>
                  )}
                  Export Contacts to Excel
                </MenuItem>
              )}
              {hasImportUserExcelPermission && (
                <div>
                  <hr className={classes.horisontalRule} />
                  <MenuItem
                    onClick={handleClickDownloadAsExcel}
                    disabled={downloadingTemplate}
                  >
                    {downloadingTemplate && (
                      <span className={classes.circularProgress}>
                        <CircularProgress size={'15px'} />
                      </span>
                    )}
                    Download Template
                  </MenuItem>
                </div>
              )}
            </Menu>
          </div>
        )}

        {hasCreatePermission && title && (
          <Button
            className={classes.firstButtonStyle}
            variant="contained"
            color="primary"
            href={createUrl}
          >
            {title}
          </Button>
        )}

        <Dialog
          open={importModelViewToggle}
          aria-label="Import Contacts from Excel"
          maxWidth={false}
          onClose={(event, reason) => {
            if (reason === 'backdropClick') return null;
            if (reason === 'escapeKeyDown') return handleCloseImportClick();
          }}
          classes={{
            paperWidthFalse: classes.paperWidthFalse // class name, e.g. `classes-nesting-root-x`
          }}
        >
          <DialogTitleWithCloseButton onClose={handleCloseImportClick}>
            Import Contacts from Excel
          </DialogTitleWithCloseButton>

          <DialogContent>
            <div>
              <CustomSimpleForm
                variant="standard"
                toolbar={null}
                margin="normal"
              >
                <FormDataConsumer>
                  {({ formData, ...rest }) => (
                    <Grid>
                      {!isFileFieldDisabled && (
                        <StyledFileInput
                          source="file"
                          label="Import File *"
                          accept={
                            'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                          }
                          placeholder="Drag and drop File Here or Upload"
                          variant="standard"
                          onChange={value => cleanUpData(value)}
                        >
                          <FileField
                            source="src"
                            title="title"
                            size="size"
                            type="type"
                          />
                        </StyledFileInput>
                      )}
                      {loaderVisible && <Loading />}
                      {validateButtonVisibile && (
                        <div className={classes.validateButton}>
                          <p className={classes.validateButtonText}>
                            No Data To Display
                            <br />
                            Click 'Validate' to parse and display Excel Data
                          </p>
                          <Button
                            onClick={() => handleClickValidation(formData)}
                            color="primary"
                            variant="contained"
                          >
                            Validate
                          </Button>
                        </div>
                      )}

                      {showGrid && (
                        <div className={classes.root}>
                          <TabContext value={value}>
                            <AppBar
                              position="static"
                              className={classes.tabsStyle}
                            >
                              <TabList
                                onChange={handleChange}
                                aria-label="simple tabs example"
                              >
                                <Tab
                                  label="Add Or Modify Contact"
                                  selectionFollowsFocus
                                  value="1"
                                  component={() => {
                                    if (tab1ContainsErrors) {
                                      return (
                                        <Button onClick={() => setValue('1')}>
                                          <ErrorImage /> Add Or Modify Contact
                                        </Button>
                                      );
                                    } else if (tab1ContainsWarning) {
                                      return (
                                        <Button onClick={() => setValue('1')}>
                                          <WarningImage /> Add Or Modify Contact
                                        </Button>
                                      );
                                    } else {
                                      return (
                                        <Button onClick={() => setValue('1')}>
                                          Add Or Modify Contact
                                        </Button>
                                      );
                                    }
                                  }}
                                />
                                <Tab
                                  label="Add or Modify Permissions"
                                  value="2"
                                  component={() => {
                                    if (tab2ContainsErrors) {
                                      return (
                                        <Button onClick={() => setValue('2')}>
                                          <ErrorImage /> Add or Modify
                                          Permissions
                                        </Button>
                                      );
                                    } else {
                                      return (
                                        <Button onClick={() => setValue('2')}>
                                          Add or Modify Permissions
                                        </Button>
                                      );
                                    }
                                  }}
                                />
                                <Tab
                                  label="Remove Permissions"
                                  value="3"
                                  component={() => {
                                    if (tab3ContainsErrors) {
                                      return (
                                        <Button onClick={() => setValue('3')}>
                                          <ErrorImage /> Remove Permissions
                                        </Button>
                                      );
                                    } else {
                                      return (
                                        <Button onClick={() => setValue('3')}>
                                          Remove Permissions
                                        </Button>
                                      );
                                    }
                                  }}
                                />
                                <Tab
                                  label="Add or Modify Roles"
                                  value="4"
                                  component={() => {
                                    if (tab4ContainsErrors) {
                                      return (
                                        <Button onClick={() => setValue('4')}>
                                          <ErrorImage /> Add or Modify Roles
                                        </Button>
                                      );
                                    } else {
                                      return (
                                        <Button onClick={() => setValue('4')}>
                                          Add or Modify Roles
                                        </Button>
                                      );
                                    }
                                  }}
                                />
                                <Tab
                                  label="Remove Roles"
                                  value="5"
                                  component={() => {
                                    if (tab5ContainsErrors) {
                                      return (
                                        <Button onClick={() => setValue('5')}>
                                          <ErrorImage /> Remove Roles
                                        </Button>
                                      );
                                    } else {
                                      return (
                                        <Button onClick={() => setValue('5')}>
                                          Remove Roles
                                        </Button>
                                      );
                                    }
                                  }}
                                />
                                <Tab
                                  label="Add Notifications"
                                  value="6"
                                  component={() => {
                                    if (tab6ContainsErrors) {
                                      return (
                                        <Button onClick={() => setValue('6')}>
                                          <ErrorImage /> Add Notifications
                                        </Button>
                                      );
                                    } else {
                                      return (
                                        <Button onClick={() => setValue('6')}>
                                          Add Notifications
                                        </Button>
                                      );
                                    }
                                  }}
                                />
                                <Tab
                                  label="Remove Notifications"
                                  value="7"
                                  component={() => {
                                    if (tab7ContainsErrors) {
                                      return (
                                        <Button onClick={() => setValue('7')}>
                                          <ErrorImage /> Remove Notifications
                                        </Button>
                                      );
                                    } else {
                                      return (
                                        <Button onClick={() => setValue('7')}>
                                          Remove Notifications
                                        </Button>
                                      );
                                    }
                                  }}
                                />
                                <Tab
                                  label="Properties"
                                  value="8"
                                  component={() => {
                                    if (tab8ContainsErrors) {
                                      return (
                                        <Button onClick={() => setValue('8')}>
                                          <ErrorImage /> Properties
                                        </Button>
                                      );
                                    } else if (tab8ContainsWarning) {
                                      return (
                                        <Button onClick={() => setValue('8')}>
                                          <WarningImage /> Properties
                                        </Button>
                                      );
                                    } else {
                                      return (
                                        <Button onClick={() => setValue('8')}>
                                          Properties
                                        </Button>
                                      );
                                    }
                                  }}
                                />
                              </TabList>
                            </AppBar>
                            <TabPanel value="1" selected={true}>
                              <div className={classes.tableWrapper}>
                                <Table
                                  stickyHeader
                                  aria-label="sticky table"
                                  size="small"
                                  className={classes.table}
                                >
                                  <TableHead>
                                    <TableRow>
                                      {[
                                        { id: 'Row Number' },
                                        { id: 'Email' },
                                        { id: 'First Name' },
                                        { id: 'Middle Name' },
                                        { id: 'Last Name' },
                                        { id: 'User Type' },
                                        { id: 'Status' },
                                        { id: 'Company Name' },
                                        { id: 'Email Opt Out' },
                                        { id: 'Receive Daily Summary' },
                                        { id: 'Title' },
                                        { id: 'Salutation' },
                                        { id: 'Suffix' },
                                        { id: 'CC Email' },
                                        { id: 'Sync To External Resource' },
                                        { id: 'Business Address Line 1' },
                                        { id: 'Business Address Line 2' },
                                        { id: 'Business Address Line 3' },
                                        { id: 'City' },
                                        { id: 'State/Province' },
                                        { id: 'ZIP/Postal Code' },
                                        { id: 'Country' },
                                        { id: 'Phone Number' },
                                        { id: 'Extension' },
                                        { id: 'Profile Updated in Portal' },
                                        {
                                          id:
                                            'Validation Error / Warning message'
                                        }
                                      ].map((headCell, index) => (
                                        <TableCell
                                          className={classes.cell}
                                          key={headCell.id}
                                          sortDirection={
                                            orderBy === index ? order : false
                                          }
                                        >
                                          <TableSortLabel
                                            active={orderBy === index}
                                            direction={order}
                                            onClick={() =>
                                              handleRequestSort(index)
                                            }
                                          >
                                            {headCell.id}
                                          </TableSortLabel>
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {response.map((item, index) => {
                                      return (
                                        <TableRow key={index} hover>
                                          <TableCell>{item.rowNum}</TableCell>
                                          <TableCell>{item.email}</TableCell>
                                          <TableCell>
                                            {item.firstName}
                                          </TableCell>
                                          <TableCell>
                                            {item.middleName}
                                          </TableCell>
                                          <TableCell>{item.lastName}</TableCell>
                                          <TableCell>{item.userType}</TableCell>
                                          <TableCell>{item.status}</TableCell>
                                          <TableCell>
                                            {item.companyName}
                                          </TableCell>
                                          <TableCell>
                                            {item.emailOptOut}
                                          </TableCell>
                                          <TableCell>
                                            {item.receiveDailySummary}
                                          </TableCell>
                                          <TableCell>{item.title}</TableCell>
                                          <TableCell>
                                            {item.salutation}
                                          </TableCell>
                                          <TableCell>{item.suffix}</TableCell>
                                          <TableCell>{item.ccEmail}</TableCell>
                                          <TableCell>
                                            {item.syncToExternalResource}
                                          </TableCell>
                                          <TableCell>
                                            {item.businessAddressLine1}
                                          </TableCell>
                                          <TableCell>
                                            {item.businessAddressLine2}
                                          </TableCell>
                                          <TableCell>
                                            {item.businessAddressLine3}
                                          </TableCell>
                                          <TableCell>{item.city}</TableCell>
                                          <TableCell>
                                            {item.stateOrProvince}
                                          </TableCell>
                                          <TableCell>
                                            {item.zipOrPostalCode}
                                          </TableCell>
                                          <TableCell>{item.country}</TableCell>
                                          <TableCell>
                                            {item.phoneNumber}
                                          </TableCell>
                                          <TableCell>
                                            {item.extension}
                                          </TableCell>
                                          <TableCell>
                                            {item.verifiedByUser}
                                          </TableCell>
                                          <TableCell
                                            className={
                                              tab1ContainsErrors
                                                ? classes.validationColumn
                                                : classes.validationColumnWarning
                                            }
                                          >
                                            {tab1ContainsErrors
                                              ? item.validationError
                                              : item.warningMessage}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </div>
                              {showNoDataInExcelError && (
                                <span className={classes.noRows}>
                                  There are no data in excel file to be
                                  validated. Please, provide excel file with
                                  data.
                                </span>
                              )}
                            </TabPanel>
                            <TabPanel value="2">
                              <div className={classes.tableWrapper}>
                                <Table
                                  stickyHeader
                                  aria-label="sticky table"
                                  size="small"
                                  className={classes.table}
                                >
                                  <TableHead>
                                    <TableRow>
                                      {[
                                        { id: 'Row Number' },
                                        { id: 'Email' },
                                        { id: 'Fund ID' },
                                        { id: 'Investor ID' },
                                        { id: 'Group Name' },
                                        { id: 'Validation Error' }
                                      ].map((headCell, index) => (
                                        <TableCell
                                          className={classes.cell}
                                          key={headCell.id}
                                          sortDirection={
                                            orderBy === index ? order : false
                                          }
                                        >
                                          <TableSortLabel
                                            active={orderBy === index}
                                            direction={order}
                                            onClick={() =>
                                              handleRequestTab2Sort(index)
                                            }
                                          >
                                            {headCell.id}
                                          </TableSortLabel>
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {responseTab2.map((item, index) => {
                                      return (
                                        <TableRow key={index} hover>
                                          <TableCell>{item.rowNum}</TableCell>
                                          <TableCell>
                                            {item.userEmail}
                                          </TableCell>
                                          <TableCell>{item.fundId}</TableCell>
                                          <TableCell>
                                            {item.investorId}
                                          </TableCell>
                                          <TableCell>
                                            {item.groupName}
                                          </TableCell>
                                          <TableCell
                                            className={classes.validationColumn}
                                          >
                                            {item.validationError}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </div>
                              {showNoDataInExcelError && (
                                <span className={classes.noRows}>
                                  There are no data in excel file to be
                                  validated. Please, provide excel file with
                                  data.
                                </span>
                              )}
                            </TabPanel>
                            <TabPanel value="3">
                              <div className={classes.tableWrapper}>
                                <Table
                                  stickyHeader
                                  aria-label="sticky table"
                                  size="small"
                                  className={classes.table}
                                >
                                  <TableHead>
                                    <TableRow>
                                      {[
                                        { id: 'Row Number' },
                                        { id: 'Email' },
                                        { id: 'Fund ID' },
                                        { id: 'Investor ID' },
                                        { id: 'Group Name' },
                                        { id: 'Validation Error' }
                                      ].map((headCell, index) => (
                                        <TableCell
                                          className={classes.cell}
                                          key={headCell.id}
                                          sortDirection={
                                            orderBy === index ? order : false
                                          }
                                        >
                                          <TableSortLabel
                                            active={orderBy === index}
                                            direction={order}
                                            onClick={() =>
                                              handleRequestTab3Sort(index)
                                            }
                                          >
                                            {headCell.id}
                                          </TableSortLabel>
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {responseTab3.map((item, index) => {
                                      return (
                                        <TableRow key={index} hover>
                                          <TableCell>{item.rowNum}</TableCell>
                                          <TableCell>
                                            {item.userEmail}
                                          </TableCell>
                                          <TableCell>{item.fundId}</TableCell>
                                          <TableCell>
                                            {item.investorId}
                                          </TableCell>
                                          <TableCell>
                                            {item.groupName}
                                          </TableCell>
                                          <TableCell
                                            className={classes.validationColumn}
                                          >
                                            {item.validationError}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </div>
                              {showNoDataInExcelError && (
                                <span className={classes.noRows}>
                                  There are no data in excel file to be
                                  validated. Please, provide excel file with
                                  data.
                                </span>
                              )}
                            </TabPanel>
                            <TabPanel value="4">
                              <div className={classes.tableWrapper}>
                                <Table
                                  stickyHeader
                                  aria-label="sticky table"
                                  size="small"
                                  className={classes.table}
                                >
                                  <TableHead>
                                    <TableRow>
                                      {[
                                        { id: 'Row Number' },
                                        { id: 'Email' },
                                        { id: 'Role Name' },
                                        { id: 'Validation Error' }
                                      ].map((headCell, index) => (
                                        <TableCell
                                          className={classes.cell}
                                          key={headCell.id}
                                          sortDirection={
                                            orderBy === index ? order : false
                                          }
                                        >
                                          <TableSortLabel
                                            active={orderBy === index}
                                            direction={order}
                                            onClick={() =>
                                              handleRequestTab4Sort(index)
                                            }
                                          >
                                            {headCell.id}
                                          </TableSortLabel>
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {responseTab4.map((item, index) => {
                                      return (
                                        <TableRow key={index} hover>
                                          <TableCell>{item.rowNum}</TableCell>
                                          <TableCell>
                                            {item.userEmail}
                                          </TableCell>
                                          <TableCell>{item.roleName}</TableCell>
                                          <TableCell
                                            className={classes.validationColumn}
                                          >
                                            {item.validationError}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </div>
                              {showNoDataInExcelError && (
                                <span className={classes.noRows}>
                                  There are no data in excel file to be
                                  validated. Please, provide excel file with
                                  data.
                                </span>
                              )}
                            </TabPanel>
                            <TabPanel value="5">
                              <div className={classes.tableWrapper}>
                                <Table
                                  stickyHeader
                                  aria-label="sticky table"
                                  size="small"
                                  className={classes.table}
                                >
                                  <TableHead>
                                    <TableRow>
                                      {[
                                        { id: 'Row Number' },
                                        { id: 'Email' },
                                        { id: 'Role Name' },
                                        { id: 'Validation Error' }
                                      ].map((headCell, index) => (
                                        <TableCell
                                          className={classes.cell}
                                          key={headCell.id}
                                          sortDirection={
                                            orderBy === index ? order : false
                                          }
                                        >
                                          <TableSortLabel
                                            active={orderBy === index}
                                            direction={order}
                                            onClick={() =>
                                              handleRequestTab5Sort(index)
                                            }
                                          >
                                            {headCell.id}
                                          </TableSortLabel>
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {responseTab5.map((item, index) => {
                                      return (
                                        <TableRow key={index} hover>
                                          <TableCell>{item.rowNum}</TableCell>
                                          <TableCell>
                                            {item.userEmail}
                                          </TableCell>
                                          <TableCell>{item.roleName}</TableCell>
                                          <TableCell
                                            className={classes.validationColumn}
                                          >
                                            {item.validationError}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </div>
                              {showNoDataInExcelError && (
                                <span className={classes.noRows}>
                                  There are no data in excel file to be
                                  validated. Please, provide excel file with
                                  data.
                                </span>
                              )}
                            </TabPanel>
                            <TabPanel value="6">
                              <div className={classes.tableWrapper}>
                                <Table
                                  stickyHeader
                                  aria-label="sticky table"
                                  size="small"
                                  className={classes.table}
                                >
                                  <TableHead>
                                    <TableRow>
                                      {[
                                        { id: 'Row Number' },
                                        { id: 'Email' },
                                        { id: 'Fund ID' },
                                        { id: 'Investor ID' },
                                        { id: 'Document Type' },
                                        { id: 'Validation Error' }
                                      ].map((headCell, index) => (
                                        <TableCell
                                          className={classes.cell}
                                          key={headCell.id}
                                          sortDirection={
                                            orderBy === index ? order : false
                                          }
                                        >
                                          <TableSortLabel
                                            active={orderBy === index}
                                            direction={order}
                                            onClick={() =>
                                              handleRequestTab6And7Sort(
                                                index,
                                                responseTab6
                                              )
                                            }
                                          >
                                            {headCell.id}
                                          </TableSortLabel>
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {responseTab6.map((item, index) => {
                                      return (
                                        <TableRow key={index} hover>
                                          <TableCell>{item.rowNum}</TableCell>
                                          <TableCell>
                                            {item.userEmail}
                                          </TableCell>
                                          <TableCell>{item.fundId}</TableCell>
                                          <TableCell>
                                            {item.investorId}
                                          </TableCell>
                                          <TableCell>
                                            {item.documentType}
                                          </TableCell>
                                          <TableCell
                                            className={classes.validationColumn}
                                          >
                                            {item.validationError}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </div>
                              {showNoDataInExcelError && (
                                <span className={classes.noRows}>
                                  There are no data in excel file to be
                                  validated. Please, provide excel file with
                                  data.
                                </span>
                              )}
                            </TabPanel>
                            <TabPanel value="7">
                              <div className={classes.tableWrapper}>
                                <Table
                                  stickyHeader
                                  aria-label="sticky table"
                                  size="small"
                                  className={classes.table}
                                >
                                  <TableHead>
                                    <TableRow>
                                      {[
                                        { id: 'Row Number' },
                                        { id: 'Email' },
                                        { id: 'Fund ID' },
                                        { id: 'Investor ID' },
                                        { id: 'Document Type' },
                                        { id: 'Validation Error' }
                                      ].map((headCell, index) => (
                                        <TableCell
                                          className={classes.cell}
                                          key={headCell.id}
                                          sortDirection={
                                            orderBy === index ? order : false
                                          }
                                        >
                                          <TableSortLabel
                                            active={orderBy === index}
                                            direction={order}
                                            onClick={() =>
                                              handleRequestTab6And7Sort(
                                                index,
                                                responseTab7
                                              )
                                            }
                                          >
                                            {headCell.id}
                                          </TableSortLabel>
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {responseTab7.map((item, index) => {
                                      return (
                                        <TableRow key={index} hover>
                                          <TableCell>{item.rowNum}</TableCell>
                                          <TableCell>
                                            {item.userEmail}
                                          </TableCell>
                                          <TableCell>{item.fundId}</TableCell>
                                          <TableCell>
                                            {item.investorId}
                                          </TableCell>
                                          <TableCell>
                                            {item.documentType}
                                          </TableCell>
                                          <TableCell
                                            className={classes.validationColumn}
                                          >
                                            {item.validationError}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </div>
                              {showNoDataInExcelError && (
                                <span className={classes.noRows}>
                                  There are no data in excel file to be
                                  validated. Please, provide excel file with
                                  data.
                                </span>
                              )}
                            </TabPanel>
                            <TabPanel value="8">
                              <div className={classes.tableWrapper}>
                                <Table
                                  stickyHeader
                                  aria-label="sticky table"
                                  size="small"
                                  className={classes.table}
                                >
                                  <TableHead>
                                    <TableRow>
                                      {propertiesDataModel ? (
                                        propertiesDataModel.map(
                                          (headCell, index) => (
                                            <TableCell
                                              className={classes.cell}
                                              key={headCell.id}
                                              sortDirection={
                                                orderBy === index
                                                  ? order
                                                  : false
                                              }
                                            >
                                              <TableSortLabel
                                                active={orderBy === index}
                                                direction={order}
                                                onClick={() =>
                                                  handleRequestTab8Sort(index)
                                                }
                                              >
                                                {headCell.id}
                                              </TableSortLabel>
                                            </TableCell>
                                          )
                                        )
                                      ) : (
                                        <span className={classes.noRowsBlack}>
                                          There are no data in excel file to be
                                          validated. The sheet is empty.
                                        </span>
                                      )}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {responseTab8.map((item, index) => {
                                      return (
                                        <TableRow key={index} hover>
                                          <TableCell>
                                            {item.rowNumber}
                                          </TableCell>
                                          <TableCell>{item.email}</TableCell>

                                          {item.validatedFieldUdfModels.map(
                                            cell => (
                                              <TableCell>
                                                {cell.fieldValue}
                                              </TableCell>
                                            )
                                          )}

                                          <TableCell
                                            className={
                                              tab8ContainsErrors
                                                ? classes.validationColumn
                                                : classes.validationColumnWarning
                                            }
                                          >
                                            {tab8ContainsErrors
                                              ? item.validationError
                                              : item.warningMessage}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </div>
                              {showNoDataInExcelError && (
                                <span className={classes.noRows}>
                                  There are no data in excel file to be
                                  validated. Please, provide excel file with
                                  data.
                                </span>
                              )}
                            </TabPanel>
                          </TabContext>
                        </div>
                      )}
                    </Grid>
                  )}
                </FormDataConsumer>
              </CustomSimpleForm>
            </div>
          </DialogContent>
          <DialogActions style={{ borderTop: `1px solid rgba(0, 0, 0, 0.12)` }}>
            <div className={classes.leftWrapper}>
              <Button
                onClick={handleCloseImportClick}
                color="primary"
                variant="outlined"
                className={classes.button}
              >
                Close
              </Button>
            </div>
            <Button
              onClick={() => handleImportContactsClick(excelFileData)}
              color="primary"
              variant="contained"
              className={classes.button}
              disabled={disableImportButton}
            >
              Import
            </Button>
          </DialogActions>
        </Dialog>
      </Toolbar>
    );
  }
);

export default ExcelContactImportTitleBarWithDropbox;
